import SEMPage from '../../components/SEMPage/sem-old'

export default SEMPage
